import { useEffectOnce } from 'react-use';

import { pubSub } from 'utils/pubSub';
import { useAppNavigate } from 'utils/url/useAppNavigate';

/** A hook that subscribes and handles global pubSub events. */
export function usePubSubGlobalEvents(): void {
  const navigate = useAppNavigate();

  useEffectOnce(() => {
    const subscriptions = [pubSub.subscribe('navigate', navigate)];

    return () => {
      subscriptions.forEach((unsubscribe) => unsubscribe());
    };
  });
}
